import { Instance } from 'mobx-state-tree';
import { OrganizationLogoUploadUrlDtoModelBase } from './OrganizationLogoUploadUrlDtoModel.base';

/* The TypeScript type of an instance of OrganizationLogoUploadUrlDtoModel */
export interface OrganizationLogoUploadUrlDtoModelType extends Instance<typeof OrganizationLogoUploadUrlDtoModel.Type> {}

/* A graphql query fragment builders for OrganizationLogoUploadUrlDtoModel */
export { selectFromOrganizationLogoUploadUrlDto, organizationLogoUploadUrlDtoModelPrimitives, OrganizationLogoUploadUrlDtoModelSelector } from './OrganizationLogoUploadUrlDtoModel.base';

/**
 * OrganizationLogoUploadUrlDtoModel
 */
export const OrganizationLogoUploadUrlDtoModel = OrganizationLogoUploadUrlDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
